export const formatDate = (date, options={time:false}) => {
    if (!date) return "N/A"; // Handle missing dates
    const formattedDate=new Date(date).toLocaleDateString("en-GB"); // Convert to DD-MM-YYYY
    const formattedTime = new Date(date).toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true, // 24-hour format
    });

  return options.time? `${formattedDate} ${formattedTime}`:`${formattedDate}`;
};